export default __webpack_public_path__ + "static/media/YES_FaceTracking.9d1ed15f.jpg";